import type {ApiResponseData} from '@frontend/types/AppTypes'
import type {
    UserData,
    UserInfoResponseData,
} from '@frontend/types/User'
import {TrackingService} from '@shared/services/TrackingService'
import {
    ApiRequestService,
    type ApiResponse,
} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'

// API авторизации пользователя.
export const UserAuthApi = {

    // Проверить зарегистрирован ли пользователь с таким телефоном и выслать код авторизации.
    async resetPassword(
        phone: string,
        recaptchaToken?: string,
        abortController?: AbortController
    ): Promise<RequestPhoneVerificationCodeResponseData> {
        return ApiRequestService
            .post<RequestPhoneVerificationCodeResponseData>(
                '/v1/reset-password',
                {
                    phone,
                    trackingId: TrackingService.getTrackingId(),
                    recaptchaResponse: recaptchaToken || null,
                },
                undefined,
                abortController
            )
            .then(response => response.data)
    },

    // Отправка кода проверки номера телефона для регистрации.
    async requestPhoneVerificationCode(
        phone: string,
        recaptchaToken?: string,
        abortController?: AbortController
    ): Promise<RequestPhoneVerificationCodeResponseData> {
        return ApiRequestService
            .post<RequestPhoneVerificationCodeResponseData>(
                '/v1/registration/send-code',
                {
                    phone,
                    trackingId: TrackingService.getTrackingId(),
                    recaptchaResponse: recaptchaToken || null,
                },
                undefined,
                abortController
            )
            .then(response => response.data)
    },

    // Авторизация пользователя по телефону и коду авторизации.
    async login(
        phone: string,
        verificationCode: string,
        abortController?: AbortController
    ): Promise<UserData> {
        return ApiRequestService
            .post<UserInfoResponseData>(
                '/v1/login',
                {
                    phone,
                    code: verificationCode,
                    trackingId: TrackingService.getTrackingId(),
                },
                undefined,
                abortController
            )
            .then(response => response.data.user)
    },

    // Выход из аккаунта.
    async logout(abortController?: AbortController): Promise<ApiResponse> {
        return ApiRequestService.get(
            '/v1/logout',
            undefined,
            undefined,
            abortController
        )
    },
}

interface RequestPhoneVerificationCodeResponseData extends ApiResponseData {
    resend_timeout?: number
}
